import { buildTokenStyle } from '../../widget-native/viewir/tokens';

export const C = {
  text: '#1C1C1E',
  textDim: '#6E6E73',
  textFaint: '#8E8E93',
  border: '#E5E5EA',
  bg: '#FFFFFF',
  bgMuted: '#F5F5F7',
  accent: '#3478F6',
  green: '#2E9B57',
  red: '#D70015',
  orange: '#C45A00',
  font: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
};

export const S = {
  card: {
    border: `1px solid ${C.border}`,
    borderRadius: 14,
    background: C.bg,
    padding: '14px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    maxWidth: 480,
    boxSizing: 'border-box',
    fontFamily: C.font,
    color: C.text,
    minWidth: 0,
  },
  title: { fontSize: 16, fontWeight: 700, lineHeight: 1.3, margin: 0 },
  sub: { fontSize: 13, color: C.textDim, lineHeight: 1.4, margin: 0 },
  row: { display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 },
  actions: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  btnPrimary: {
    flex: 1, minWidth: 120, padding: '10px 14px', borderRadius: 10, border: 'none',
    background: C.text, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: C.font,
  },
  btnSecondary: {
    flex: 1, minWidth: 120, padding: '10px 14px', borderRadius: 10, border: `1px solid ${C.border}`,
    background: C.bg, color: C.text, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: C.font,
  },
  btnLink: {
    border: 'none', background: 'transparent', color: C.accent, fontSize: 13, fontWeight: 600,
    cursor: 'pointer', padding: 0, fontFamily: C.font,
  },
  disabled: { opacity: 0.45, cursor: 'default' },
  chip: {
    display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999,
    background: C.bgMuted, color: C.textDim, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0,
  },
  footnote: { fontSize: 11.5, color: C.textFaint, textAlign: 'center', margin: 0 },
  ellipsis: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 },
  assistant: { width: '100%', maxWidth: 'min(78%, 480px)', alignSelf: 'flex-start', borderRadius: 16, padding: '10px 12px' },
  error: { fontSize: 12.5, color: C.red, margin: 0, overflowWrap: 'anywhere' },
  warn: { fontSize: 12.5, color: C.orange, margin: 0 },
  input: {
    width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: 8,
    border: `1px solid ${C.border}`, fontSize: 14, fontFamily: C.font, color: C.text, background: C.bg,
  },
  label: { fontSize: 11, fontWeight: 600, color: C.textFaint, textTransform: 'uppercase', letterSpacing: 0.4 },
};

export function clampLines(lines) {
  return {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    overflow: 'hidden',
    overflowWrap: 'anywhere',
  };
}

export function btn(base, disabled) {
  return disabled ? { ...base, ...S.disabled } : base;
}

/** The native kit's CSS variables, so a kit ActionRow draws in a chat card. */
export const KIT_VARS = Object.fromEntries(
  Object.entries(buildTokenStyle({ appearance: 'light' })).filter(([k]) => k.startsWith('--')),
);

/** The outer box of a one-row chat card: the assistant bubble's width, no chrome of its own. */
export const ROW_BOX = {
  ...KIT_VARS,
  width: '100%', maxWidth: 'min(78%, 480px)', alignSelf: 'flex-start', borderRadius: 16,
  boxSizing: 'border-box', fontFamily: C.font, minWidth: 0, display: 'flex', flexDirection: 'column',
};
